import * as React from 'react';
import {useStyletron} from 'baseui';
import {Button, KIND, SHAPE, SIZE} from 'baseui/button';
import Hide from 'baseui/icon/hide';

export default function NoContentComponent(
    {
        onRefresh,
        message ,
    }
) {
  const [css, theme] = useStyletron();
  return (
    <div
      className={css({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      <Hide 
        overrides={{
          Svg: {
            style: {
              color: theme.colors.primary,
            },
          },
        }}
       size={theme.sizing.scale1600} />
      <div
        className={css({
          ...theme.typography.HeadingXSmall,
          paddingBlockStart: theme.sizing.scale650,
          paddingBlockEnd: theme.sizing.scale500,
        })}
      >
        {`No Content Found`}
      </div>     
      <Button
        onClick={onRefresh}
        kind={KIND.secondary}
        shape={SHAPE.pill}
        size={SIZE.compact}
      >
        Try Again
      </Button>
    </div>
  );
}